import React, { useState, CSSProperties } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import "./callpanel/components/Preview/DialPad.css";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};


function Loading() {
  const [loading, setLoading] = useState(true);
  const [color, setColor] = useState("#4e80c5");

  return (
    <span className="sweet-loading">
      <ClipLoader
        color={color}
        loading={loading}
        css={override} 
        size={30}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </span>
  );
}

export default Loading;
